import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTODiffusionModelUDBase } from '../sd/_base/dto_diffusion_model_ud_base';
import { DTODiffusionModelsTablePageBase } from '../table_base/dto_diffusion_model_table_page_base';

export class DTODiffusionModelsTablePageUD extends DTODiffusionModelsTablePageBase<DTODiffusionModelUDBase> {
  /*
   * STATIC FIELDS
   */

  static readonly _class_name_static: string = ENUM__dto_class_name.DIFFUSION_MODELS_TABLE_PAGE_UD;

  /*
   * FIELDS
   */
}
